import { normalizeEmail } from "./whatsappEmail/threadGrouping";

/** Extrae nombre visible y email de un campo From/To. */
export function parseContactField(raw) {
  const text = String(raw || "").trim();
  if (!text) return { name: "", email: "" };

  const bracket = text.match(/^(.*?)\s*<([^>]+)>\s*$/);
  if (bracket) {
    const name = bracket[1].replace(/^["']|["']$/g, "").trim();
    const email = normalizeEmail(bracket[2]);
    return { name, email };
  }

  const email = normalizeEmail(text);
  if (email.includes("@")) return { name: "", email };
  return { name: text, email: "" };
}

export function extractContactName(raw) {
  if (!raw || raw === "yo-mismo") return "Yo mismo";
  const { name, email } = parseContactField(raw);
  if (name && !name.includes("@")) return name;
  if (email) return formatNameFromEmail(email);
  return String(raw).trim() || "Desconocido";
}

const GENERIC_LOCALS = new Set([
  "announce",
  "announcements",
  "noreply",
  "no-reply",
  "donotreply",
  "do-not-reply",
  "info",
  "hello",
  "notifications",
  "notification",
  "mail",
  "newsletter",
  "support",
  "contact",
  "billing",
  "receipts",
]);

export function getRootDomain(host) {
  const h = String(host || "").toLowerCase().trim();
  if (!h) return "";
  const parts = h.split(".").filter(Boolean);
  if (parts.length <= 2) return h;

  const twoLevel = parts.slice(-2).join(".");
  const threeLevelTlds = ["co.uk", "com.br", "com.au", "co.jp", "com.mx"];
  if (threeLevelTlds.some((t) => h.endsWith(t)) && parts.length >= 3) {
    return parts.slice(-3).join(".");
  }

  if (["m", "mail", "www", "em", "e", "go", "email", "messages"].includes(parts[0])) {
    return parts.slice(1).join(".");
  }

  return twoLevel;
}

export function formatNameFromEmail(email) {
  const norm = normalizeEmail(email);
  if (!norm || !norm.includes("@")) return norm || "Desconocido";

  const [local, domain] = norm.split("@");
  const root = getRootDomain(domain);
  const brand = root.split(".")[0] || local;

  if (
    GENERIC_LOCALS.has(local) ||
    local.startsWith("noreply") ||
    local.includes("notification")
  ) {
    return brand.charAt(0).toUpperCase() + brand.slice(1);
  }

  return local
    .split(/[._-]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export function getContactRawField(last, contactEmail) {
  if (!last) return contactEmail || "";
  if (contactEmail === "yo-mismo") return "Yo mismo";

  const target = normalizeEmail(contactEmail);
  if (!target) return last.from || "";

  if (last.direction === "sent") {
    const toRaw = String(last.to_email || "");
    for (const part of toRaw.split(",")) {
      if (normalizeEmail(part) === target) return part.trim();
    }
    return toRaw || contactEmail;
  }

  if (normalizeEmail(last.from) === target) return last.from || contactEmail;
  return last.from || contactEmail;
}

export function getContactDisplayName(last, contactEmail) {
  if (contactEmail === "yo-mismo") return "Yo mismo";
  const raw = getContactRawField(last, contactEmail);
  return extractContactName(raw);
}

export function getContactEmailForAvatar(contactEmail, last) {
  if (contactEmail === "yo-mismo") return normalizeEmail(last?.accountEmail) || "";
  const raw = getContactRawField(last, contactEmail);
  const parsed = parseContactField(raw);
  return parsed.email || normalizeEmail(contactEmail) || "";
}

export function getFaviconUrl(email) {
  const norm = normalizeEmail(email);
  if (!norm.includes("@")) return null;
  const domain = getRootDomain(norm.split("@")[1]);
  if (!domain) return null;
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=64`;
}

export function contactInitial(displayName, email) {
  const base = String(displayName || email || "?").trim();
  if (!base) return "?";
  if (base.includes(" ")) {
    const parts = base.split(/\s+/).filter(Boolean);
    return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
  }
  return base.charAt(0).toUpperCase();
}

export function stringToColor(str) {
  let hash = 0;
  const s = String(str || "");
  for (let i = 0; i < s.length; i++) {
    hash = s.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 58%, 42%)`;
}
